// /wallet-ops/config/policies → the withdrawal list. Keeps pre-SM-278
// bookmarks (the old single Policies page) landing somewhere useful.
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/wallet-ops/config/policies/")({
  beforeLoad: () => {
    throw redirect({
      to: "/wallet-ops/config/policies/withdrawal",
      replace: true,
    });
  },
});
